// Fallback toast hook - redirects to sonner
import { toast as sonnerToast } from 'sonner';

export const useToast = () => {
  return {
    toast: (options: any) => {
      const message = options.description || options.title || '';
      
      if (options.variant === 'destructive') {
        sonnerToast.error(message);
      } else {
        sonnerToast.success(message);
      }
    }
  };
};

// Comprehensive toast function with all methods
export const toast = (options: any) => {
  const message = options.description || options.title || '';
  
  if (options.variant === 'destructive') {
    sonnerToast.error(message);
  } else {
    sonnerToast.success(message);
  }
};

// Add all the missing methods with object support
toast.success = (messageOrOptions: string | any) => {
  if (typeof messageOrOptions === 'string') {
    sonnerToast.success(messageOrOptions);
  } else {
    sonnerToast.success(messageOrOptions.description || messageOrOptions.title || '');
  }
};
toast.error = (messageOrOptions: string | any) => {
  if (typeof messageOrOptions === 'string') {
    sonnerToast.error(messageOrOptions);
  } else {
    sonnerToast.error(messageOrOptions.description || messageOrOptions.title || '');
  }
};
toast.warning = (messageOrOptions: string | any) => {
  if (typeof messageOrOptions === 'string') {
    sonnerToast.warning(messageOrOptions);
  } else {
    sonnerToast.warning(messageOrOptions.description || messageOrOptions.title || '');
  }
};
toast.info = (messageOrOptions: string | any) => {
  if (typeof messageOrOptions === 'string') {
    sonnerToast.info(messageOrOptions);
  } else {
    sonnerToast.info(messageOrOptions.description || messageOrOptions.title || '');
  }
};

// Export behtariToast as alias for compatibility
export const behtariToast = toast;